/**
 * Componente de Debug para visualizar permissões do usuário
 * APENAS PARA DESENVOLVIMENTO
 */

import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { usePermissions } from "@/hooks/usePermissions";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useEnvironment } from "@/hooks/useEnvironment";

export const PermissionsDebug: React.FC = () => {
  const { user } = useAuth();
  const { permissions, isAdmin } = usePermissions();
  const { showProfileSelector, isProduction } = useEnvironment();

  // Só mostrar em desenvolvimento
  if (isProduction || !showProfileSelector) {
    return null;
  }

  return (
    <Card className="mt-4 border-amber-200 bg-amber-50">
      <CardHeader>
        <CardTitle className="text-sm flex items-center gap-2">
          🔍 Debug de Permissões
          <Badge variant="outline" className="text-xs">
            DEV
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div>
          <p className="text-xs font-semibold text-gray-700">Usuário:</p>
          <p className="text-xs text-gray-600">{user?.name || "N/A"}</p>
        </div>

        <div>
          <p className="text-xs font-semibold text-gray-700">Perfil Atual:</p>
          <p className="text-xs text-gray-600">
            {user?.profile_name || "N/A"}
            {user?.profile_id && (
              <span className="text-gray-400 ml-2">({user.profile_id.substring(0, 8)}...)</span>
            )}
          </p>
        </div>

        <div>
          <p className="text-xs font-semibold text-gray-700 mb-1">
            É Admin: {isAdmin ? "✅ Sim" : "❌ Não"}
          </p>
        </div>

        <div>
          <p className="text-xs font-semibold text-gray-700 mb-1">
            Permissões ({permissions.length}):
          </p>
          <div className="flex flex-wrap gap-1 max-h-32 overflow-y-auto">
            {permissions.length === 0 ? (
              <Badge variant="destructive" className="text-xs">
                Nenhuma permissão carregada
              </Badge>
            ) : (
              permissions.map((permission) => (
                <Badge
                  key={permission.name}
                  variant="secondary"
                  className="text-xs"
                >
                  {permission.name}
                </Badge>
              ))
            )}
          </div>
        </div>

        <div className="pt-2 border-t border-amber-200">
          <p className="text-xs text-amber-700">
            💡 Selecione um perfil acima para ver as permissões mudarem
          </p>
          <p className="text-xs text-amber-600 mt-1">
            ℹ️ Os menus exibidos são filtrados dinamicamente pelas permissões reais
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

